import RecoverStep from "./recover_step";
import axios from "../../../axios-instance";
import {REPLIBIT_RECOVER_TYPE, BRC_RECOVER_TYPE} from "../utils/recover_consts";

const TEMPLATE = 'client-select';

export default class ClientSelect extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.tmp = {previousStep: fr.currentStep};
        data.render = {readyToRender: false};
        this.loadClients(data, el, fr);
    }

    loadClients(data, el, fr) {
        axios.get(`/reseller/get_reseller_clients/${data.resellerId}`).then(response => {
            const responseData = response.data;
            if (responseData?.table_data?.data?.length === 1) {
                const client = responseData.table_data?.data[0];
                if (client?.machines_latest_schedule_rp_count > 0) {
                    this.goToNextStep(client, data, fr, true);
                    return;
                }
            }
            data.render.clientsTable = responseData.table_data;
            data.render.readyToRender = true;
            fr.render();
            this.initTable(data, el, fr);
        }).catch(() => {
            fr.defaultAJAXErrorHandler()
        });
    }

    initTable(data, el, fr) {
        const stepElement = document.querySelector('.flowmodal[data-step="client-select"]')
        const table = stepElement.querySelector('#recovery-flow-client-select-table')
        const columns = data.render.clientsTable.columns;
        const clientData = data.render.clientsTable.data;
        const tableData = this.prepareTableRenderData(clientData);
        table.columns = columns;
        table.data = tableData;
        table.addEventListener('rowSelected', (e) => {
            const detail = e.detail;
            const values = detail?.values();
            const clientId = values?.next()?.value;
            if (clientId) {
                const client = clientData.find(row => row.id === clientId);
                if (client) {
                    this.goToNextStep(client, data, fr);
                }
            }
        });
    }

    goToNextStep(client, data, fr, resellerHasOneClient = false) {
        let nextStep = null;
        let type = null;
        data.clientId = client.id;
        if (client.has_brc && client.has_x360recover) {
            nextStep = 'recoverToolSelect';
        } else if (client.has_brc) {
            nextStep = 'type';
            type = BRC_RECOVER_TYPE;
        } else if (client.has_x360recover) {
            nextStep = 'typeRB';
            type = REPLIBIT_RECOVER_TYPE;
        }
        data.disabledFFR = type === REPLIBIT_RECOVER_TYPE;
        data.disabledBMR = type === REPLIBIT_RECOVER_TYPE;
        data.showBackButton = !resellerHasOneClient;
        data.resellerHasOneClient = resellerHasOneClient;
        data.clientHasBrcAndX360Recover = client.has_brc && client.has_x360recover;
        data.type = type;
        fr.goTo(nextStep);
    }

    prepareTableRenderData(data) {
        const tooltip = `<axs-tooltip alignment="left">${_flow_recovery_select_client_no_rp_tooltip}</axs-tooltip>`
        return data.map(row => {
            return [
                row.machines_latest_schedule_rp_count ? row.id : null,
                row.machines_latest_schedule_rp_count ? null : tooltip,
                row.name ? this.renderName(row.name) : '',
                row.workstation_count,
                row.server_count,
                row.app_count,
            ]
        });
    }

    renderName(name) {
        return `<span title="${name}">${name}</span>`;
    }
}
